"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERESTS_ES = exports.INTERESTS_EN = exports.INTERESTS = void 0;
exports.INTERESTS = {
    tech: [
        {
            label: 'Biotecnologia',
            value: 'biotechnology',
        },
        {
            label: 'Blockchain',
            value: 'blockchain',
        },
        {
            label: 'Cyber-Segurança',
            value: 'cybersecurity',
        },
        {
            label: 'Dispositivos',
            value: 'devices',
        },
        {
            label: 'Energia limpa',
            value: 'clean_energy',
        },
        {
            label: 'Exploração espacial',
            value: 'space_exploration',
        },
        {
            label: 'Impressão 3d',
            value: '3d_printing',
        },
        {
            label: 'Inteligência artificial',
            value: 'artificial_intelligence',
        },
        {
            label: 'Internet das coisas',
            value: 'iot',
        },
        {
            label: 'Robótica',
            value: 'robotics',
        },
        {
            label: 'Poder da computação',
            value: 'computing_power',
        },
        {
            label: 'Realidade virtual',
            value: 'virtual_reality',
        },
        {
            label: 'Tecnologias disruptivas',
            value: 'disruptive_technologies',
        },
    ],
    management: [
        {
            label: 'Aprendizagem Organizacional',
            value: 'organizational_learning',
            big: true,
        },
        {
            label: 'Concorrência',
            value: 'competition',
        },
        {
            label: 'Cultura empresarial',
            value: 'corporate_culture',
        },
        {
            label: 'Estratégia de negócios',
            value: 'business_strategy',
        },
        {
            label: 'Gestão da inovação',
            value: 'innovation_management',
        },
        {
            label: 'Gestão de clientes',
            value: 'client_management',
        },
        {
            label: 'Gestão de pessoas',
            value: 'people_management',
        },
        {
            label: 'Gestão financeira',
            value: 'financial_management',
        },
        {
            label: 'Governança corporativa',
            value: 'corporate_governance',
        },
        {
            label: 'Inovação aberta',
            value: 'open_innovation',
        },
        {
            label: 'Marketing & vendas',
            value: 'marketing_and_sales',
        },
        {
            label: 'Operações e logística',
            value: 'operations_logistics',
        },
        {
            label: 'Práticas de gestão',
            value: 'management_practices',
        },
        {
            label: 'Sociedade empresarial',
            value: 'business_society',
        },
        {
            label: 'Sustentabilidade',
            value: 'sustainability',
        },
        {
            label: 'Transformação digital',
            value: 'digital_transformation',
        },
    ],
    skills: [
        {
            label: 'Diversidade',
            value: 'diversity',
        },
        {
            label: 'Criatividade',
            value: 'creativity',
        },
        {
            label: 'Empreendedorismo',
            value: 'entrepreneurship',
        },
        {
            label: 'Inteligência Emocional',
            value: 'emotional_intelligence',
        },
        {
            label: 'Modelos de negócios',
            value: 'business_models',
        },
        {
            label: 'Modelos mentais',
            value: 'mental_models',
        },
        {
            label: 'Novas habilidades humanas',
            value: 'new_human_skills',
            big: true,
        },
    ],
};
exports.INTERESTS_EN = {
    tech: [
        {
            label: 'Biotechnology',
            value: 'biotechnology',
        },
        {
            label: 'Blockchain',
            value: 'blockchain',
        },
        {
            label: 'Cyber Security',
            value: 'cybersecurity',
        },
        {
            label: 'Devices',
            value: 'devices',
        },
        {
            label: 'Clean Energy',
            value: 'clean_energy',
        },
        {
            label: 'Space Exploration',
            value: 'space_exploration',
        },
        {
            label: '3D Printing',
            value: '3d_printing',
        },
        {
            label: 'Artificial Intelligence',
            value: 'artificial_intelligence',
        },
        {
            label: 'Internet of Things',
            value: 'iot',
        },
        {
            label: 'Robotics',
            value: 'robotics',
        },
        {
            label: 'Computing Power',
            value: 'computing_power',
        },
        {
            label: 'Virtual Reality',
            value: 'virtual_reality',
        },
        {
            label: 'Disruptive Technologies',
            value: 'disruptive_technologies',
        },
    ],
    management: [
        {
            label: 'Organizational Learning',
            value: 'organizational_learning',
            big: true,
        },
        {
            label: 'Competition',
            value: 'competition',
        },
        {
            label: 'Business Culture',
            value: 'corporate_culture',
        },
        {
            label: 'Business Strategy',
            value: 'business_strategy',
        },
        {
            label: 'Innovation Management',
            value: 'innovation_management',
        },
        {
            label: 'Client Management',
            value: 'client_management',
        },
        {
            label: 'People Management',
            value: 'people_management',
        },
        {
            label: 'Financial Management',
            value: 'financial_management',
        },
        {
            label: 'Corporate Governance',
            value: 'corporate_governance',
        },
        {
            label: 'Open Innovation',
            value: 'open_innovation',
        },
        {
            label: 'Marketing & Sales',
            value: 'marketing_and_sales',
        },
        {
            label: 'Operations and Logistics',
            value: 'operations_logistics',
        },
        {
            label: 'Management Practices',
            value: 'management_practices',
        },
        {
            label: 'Business Society',
            value: 'business_society',
        },
        {
            label: 'Sustainability',
            value: 'sustainability',
        },
        {
            label: 'Digital Transformation',
            value: 'digital_transformation',
        },
    ],
    skills: [
        {
            label: 'Diversity',
            value: 'diversity',
        },
        {
            label: 'Creativity',
            value: 'creativity',
        },
        {
            label: 'Entrepreneurship',
            value: 'entrepreneurship',
        },
        {
            label: 'Emotional intelligence',
            value: 'emotional_intelligence',
        },
        {
            label: 'Business Models',
            value: 'business_models',
        },
        {
            label: 'Mental Models',
            value: 'mental_models',
        },
        {
            label: 'New Human Skills',
            value: 'new_human_skills',
            big: true,
        },
    ],
};
exports.INTERESTS_ES = {
    tech: [
        {
            label: 'Biotechnology',
            value: 'biotechnology',
        },
        {
            label: 'Blockchain',
            value: 'blockchain',
        },
        {
            label: 'Seguridad Cibernética',
            value: 'cybersecurity',
        },
        {
            label: 'Dispositivos',
            value: 'devices',
        },
        {
            label: 'Energia limpia',
            value: 'clean_energy',
        },
        {
            label: 'Exploración espacial',
            value: 'space_exploration',
        },
        {
            label: 'Impresión 3D',
            value: '3d_printing',
        },
        {
            label: 'Inteligencia Artificial',
            value: 'artificial_intelligence',
        },
        {
            label: 'Internet de las Cosas',
            value: 'iot',
        },
        {
            label: 'Robótica',
            value: 'robotics',
        },
        {
            label: 'Poder Computacional',
            value: 'computing_power',
        },
        {
            label: 'Realidad Virtual',
            value: 'virtual_reality',
        },
        {
            label: 'Tecnologías Disruptivas',
            value: 'disruptive_technologies',
        },
    ],
    management: [
        {
            label: 'Aprendizaje Organizacional',
            value: 'organizational_learning',
            big: true,
        },
        {
            label: 'Competencia',
            value: 'competition',
        },
        {
            label: 'Cultura Empresarial',
            value: 'corporate_culture',
        },
        {
            label: 'Estrategia de Negocios',
            value: 'business_strategy',
        },
        {
            label: 'Gestión de la Innovación',
            value: 'innovation_management',
        },
        {
            label: 'Gestión de Clientes',
            value: 'client_management',
        },
        {
            label: 'Gestión de Personas',
            value: 'people_management',
        },
        {
            label: 'Gestión Financiera',
            value: 'financial_management',
        },
        {
            label: 'Gobierno Corporativo',
            value: 'corporate_governance',
        },
        {
            label: 'Innovación Abierta',
            value: 'open_innovation',
        },
        {
            label: 'Márketing de ventas',
            value: 'marketing_and_sales',
        },
        {
            label: 'Operaciones y Logística',
            value: 'operations_logistics',
        },
        {
            label: 'Prácticas de manejo',
            value: 'management_practices',
        },
        {
            label: 'Sociedad Empresarial',
            value: 'business_society',
        },
        {
            label: 'Sustentabilidad',
            value: 'sustainability',
        },
        {
            label: 'Transformación Digital',
            value: 'digital_transformation',
        },
    ],
    skills: [
        {
            label: 'Diversidad',
            value: 'diversity',
        },
        {
            label: 'Creatividad',
            value: 'creativity',
        },
        {
            label: 'Emprendimiento',
            value: 'entrepreneurship',
        },
        {
            label: 'Inteligencia Emocional',
            value: 'emotional_intelligence',
        },
        {
            label: 'Modelos de Negocio',
            value: 'business_models',
        },
        {
            label: 'Modelos Mentales',
            value: 'mental_models',
        },
        {
            label: 'Nuevas Habilidades Humanas',
            value: 'new_human_skills',
            big: true,
        },
    ],
};
//# sourceMappingURL=interests.js.map